import { useState, useCallback, useEffect } from 'react';
import { message } from 'antd';
import { getCookie } from '../../../services/cookies';
import { getAsset } from '../../../services/general';
import proceduresCodes from '../../../utils/proceduresCodes.json';

export const useAudiometryChart = (inputs) => {
  const [chartImage, setChartImage] = useState();
  const [chartImageRE, setChartImageRE] = useState();
  const [chartImageLE, setChartImageLE] = useState();
  const countryCode = getCookie('country_code');

  const showChart = useCallback(async () => {
    const fetchAsset = async (code) => {
      const chartProcedure = inputs.procedures.find(procedure => procedure.code === code && procedure.document_file_name);
      if (chartProcedure) {
        return await getAsset({
          field: 'document',
          id: chartProcedure.result_id,
          type: 'AdmissionProcedureResult',
        });
      }
      return null;
    };

    try {
      const standardCode = proceduresCodes.audiometria['archivo']?.[countryCode];
      if (standardCode) {
        const asset = await fetchAsset(standardCode);
        if (asset) setChartImage(asset.document_url);
      }

      const reCode = proceduresCodes.audiometria['archivo_od']?.[countryCode];
      if (reCode) {
        const asset = await fetchAsset(reCode);
        if (asset) setChartImageRE(asset.document_url);
      }

      const leCode = proceduresCodes.audiometria['archivo_oi']?.[countryCode];
      if (leCode) {
        const asset = await fetchAsset(leCode);
        if (asset) setChartImageLE(asset.document_url);
      }
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Error al obtener gráficos de audiometría',
        style: {
          marginTop: '40vh',
        },
      });
    }
  }, [countryCode, inputs.procedures]);

  const clearChartImage = useCallback(() => {
    setChartImage(null);
    setChartImageRE(null);
    setChartImageLE(null);
  }, []);

  useEffect(() => {
    showChart();
  }, [showChart]);

  return {
    chartImage,
    chartImageRE,
    chartImageLE,
    showChart,
    clearChartImage,
    setChartImage,
    setChartImageRE,
    setChartImageLE
  };
};